export const FETCH_CARDTRONICS_CUSTOMER_LIST_REQUEST =
  "FETCH_CARDTRONICS_CUSTOMER_LIST_REQUEST";
export const FETCH_CARDTRONICS_CUSTOMER_LIST_SUCCESS =
  "FETCH_CARDTRONICS_CUSTOMER_LIST_SUCCESS";
export const FETCH_CARDTRONICS_CUSTOMER_LIST_FAILURE =
  "FETCH_CARDTRONICS_CUSTOMER_LIST_FAILURE";

export const ADD_UPDATE_CARDTRONICS_CUSTOMER_REQUEST =
  "ADD_UPDATE_CARDTRONICS_CUSTOMER_REQUEST";
export const ADD_UPDATE_CARDTRONICS_CUSTOMER_SUCCESS =
  "ADD_UPDATE_CARDTRONICS_CUSTOMER_SUCCESS";
export const ADD_UPDATE_CARDTRONICS_CUSTOMER_FAILURE =
  "ADD_UPDATE_CARDTRONICS_CUSTOMER_FAILURE";
